"use strict";

export class Accordion {
    constructor() {
        this.RUNNING_VALUE = "running";
        this.IS_OPENED_CLASS = "is-opened";

        // アニメーションの時間とイージング
        this.animTiming = {
            duration: 400,
            easing: "ease-out"
        };

        // 初期化を実行
        this.init();
    }

    init() {
        const details = document.querySelectorAll(".js-details");

        details.forEach((element) => {
            const summary = element.querySelector(".js-summary");
            const content = element.querySelector(".js-content");

            // 要素が見つからない場合はスキップ
            if (!summary || !content) return;

            summary.addEventListener("click", (event) => {
                event.preventDefault();

                // 連打防止
                if (element.dataset.animStatus === this.RUNNING_VALUE) {
                    return;
                }

                if (element.open) {
                    // 閉じる処理
                    element.classList.toggle(this.IS_OPENED_CLASS);

                    const closingAnim = content.animate(this.closingAnimKeyframes(content), this.animTiming);
                    element.dataset.animStatus = this.RUNNING_VALUE;

                    closingAnim.onfinish = () => {
                        element.removeAttribute("open");
                        element.dataset.animStatus = "";
                    };
                } else {
                    // 開く処理
                    element.setAttribute("open", "true");
                    element.classList.toggle(this.IS_OPENED_CLASS);

                    const openingAnim = content.animate(this.openingAnimKeyframes(content), this.animTiming);
                    element.dataset.animStatus = this.RUNNING_VALUE;

                    openingAnim.onfinish = () => {
                        element.dataset.animStatus = "";
                    };
                }
            });
        });
    }

    // 💡 クラス内のメソッド(関数)として定義
    closingAnimKeyframes(content) {
        return [
            {
                height: content.offsetHeight + 'px',
                opacity: 1,
            },
            {
                height: 0,
                opacity: 0,
            }
        ];
    }

    openingAnimKeyframes(content) {
        return [
            {
                height: 0,
                opacity: 0,
            },
            {
                height: content.offsetHeight + 'px',
                opacity: 1,
            }
        ];
    }
}